module.exports = __webpack_public_path__ + "static/media/mapnode-rollerskifahren-premium.9f14cfe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/assets/mapnode-rollerskifahren-premium.svg
// module id = 315
// module chunks = 0